import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { ToggleTW } from 'tailwindComponents/toggleTW/ToggleTW';
import { DateField } from 'ui-toolkit';
import { IDetailsFormData } from '../types/IDetailsFormData';
import { addDays, format } from 'date-fns';

export const DateRangeSection: React.FC = () => {
  const { values } = useFormikContext<IDetailsFormData>();
  const tomorrow = useMemo(() => format(addDays(new Date(), 1), 'yyyy-MM-dd'), []);

  return (
    <section className="flex flex-col gap-4">
      {!values.isDssDateRange && (
        <DateField
          minDate={tomorrow}
          name="dssDate"
          label="Date"
          placeholder="Select a Date"
          isRequired={values.signerSelectsFromRange}
        />
      )}
      {values.isDssDateRange && (
        <section id="dss-time-range" className="flex gap-2">
          <DateField
            minDate={tomorrow}
            name="dssDateRangeStart"
            label="Start Date"
            placeholder="Select a Date"
            isRequired={values.signerSelectsFromRange}
          />
          <DateField
            minDate={tomorrow}
            name="dssDateRangeEnd"
            label="End Date"
            placeholder="Select a Date"
            isRequired={values.signerSelectsFromRange}
          />
        </section>
      )}
      <ToggleTW name="isDssDateRange" text="Date Range" />
    </section>
  );
};
